/**
 * Pure date helpers, deliberately free of any module that touches the network or the DOM —
 * the modal view imports these, and dragging the axios client in with them breaks it under jsdom.
 */
/** Local-parts ISO date. `toISOString()` would shift a local-midnight date back a day west of UTC. */
export const toIsoDate = (date) => {
    const month = `${date.getMonth() + 1}`.padStart(2, '0');
    const day = `${date.getDate()}`.padStart(2, '0');
    return `${date.getFullYear()}-${month}-${day}`;
};
/** Day-level equality, so a time component never makes an unchanged date look edited. */
export const isSameDay = (a, b) => {
    if (!a || !b)
        return a === b;
    return toIsoDate(a) === toIsoDate(b);
};
/** Day-level "earlier than". */
export const isBefore = (a, b) => {
    if (!a || !b)
        return false;
    return toIsoDate(a) < toIsoDate(b);
};
/**
 * Mirrors `ReconcileEndDate#shortening?` — `previous_end_date.blank? || new < previous`.
 *
 * A series with no end date is unbounded, so giving it a finite one cancels everything scheduled
 * past that date. Reading it as "not a shortening" hides the count and the warning while the save
 * cancels inspections anyway, which is precisely the drift the shared cancellation scope exists to
 * prevent. Keep this in step with the Ruby predicate.
 */
export const isShortening = (next, current) => {
    if (!next)
        return false;
    if (!current)
        return true;
    return isBefore(next, current);
};
